import * as RadixTooltip from '@radix-ui/react-tooltip';
import type { TooltipProps as RadixTooltipProps, TooltipContentProps } from '@radix-ui/react-tooltip';
import * as styles from './Tooltip.css';

export type TooltipProps = Partial<Pick<TooltipContentProps, 'align'>> &
  RadixTooltipProps & {
    readonly content: string;
  };

export const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  align = 'center',
  delayDuration = 100,
  ...rest
}) => {
  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root delayDuration={delayDuration} {...rest}>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content align={align} className={styles.TooltipRoot}>
            {content}
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};
